module.exports = __webpack_public_path__ + "img/speaker-AdamNeuhaus-imgs.411ad2fe.png";